import { DRAFT_PROMPT_TEMPLATE_ID, DRAFT_PROMPT_TEMPLATE_VALUES } from '../../constants/superstoreStorageKeys';
import { getSuperStoreValue, setSuperstoreValue } from '../../utils/superStoreUtils';
/**
 * Gets both the template ID and draft values from superstore
 */
export const getDraftPromptTemplateFromSuperstore = async () => {
  const [templateId, draftValues] = await Promise.all([getSuperStoreValue(DRAFT_PROMPT_TEMPLATE_ID), getSuperStoreValue(DRAFT_PROMPT_TEMPLATE_VALUES)]);
  if (!templateId) {
    return null;
  }
  return {
    templateId,
    draftValues: draftValues || {}
  };
};

/**
 * Sets only the template ID in superstore
 */
export const setDraftPromptTemplateIdInSuperstore = async templateId => {
  await setSuperstoreValue(DRAFT_PROMPT_TEMPLATE_ID, templateId);
};

/**
 * Updates a single key-value pair in the draft values object
 */
export const setDraftPromptTemplateValuesInSuperstore = async (key, value) => {
  const currentValues = (await getSuperStoreValue(DRAFT_PROMPT_TEMPLATE_VALUES)) || {};
  const newValues = Object.assign({}, currentValues, {
    [key]: value
  });
  await setSuperstoreValue(DRAFT_PROMPT_TEMPLATE_VALUES, newValues);
};

/**
 * Clears both template ID and draft values from superstore
 */
export const clearDraftPromptTemplateFromSuperstore = async () => {
  await Promise.all([setSuperstoreValue(DRAFT_PROMPT_TEMPLATE_ID, null), setSuperstoreValue(DRAFT_PROMPT_TEMPLATE_VALUES, null)]);
};